import React, { useState, useEffect } from "react";

interface SessionClockProps {
  finalTime: number | null;
  sessionStartTime: number | null;
  stopTime: number | null;
  isSessionRunning: boolean | null;
  stoppedMilliSeconds: number | null;
}

export default function SessionClock(props: SessionClockProps) {
  const {
    finalTime,
    sessionStartTime,
    stopTime,
    isSessionRunning,
    stoppedMilliSeconds,
  } = props;
  const [currentTime, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  function secondsToMMSS(seconds: number) {
    if (isNaN(seconds)) {
      return null;
    }

    const sign = seconds < 0 ? "-" : "";
    seconds = Math.abs(seconds);

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const mm = String(minutes).padStart(2, "0");
    const ss = String(remainingSeconds).padStart(2, "0");

    return sign + mm + ":" + ss;
  }

  let timeRemaining;
  if (sessionStartTime) {
    timeRemaining =
      (finalTime || 0) +
      (stoppedMilliSeconds || 0) / 1000 -
      ((isSessionRunning ? currentTime : (stopTime || 0) * 1000) -
        sessionStartTime) /
        1000;
  } else {
    timeRemaining = finalTime || 0;
  }

  return <div>{secondsToMMSS(timeRemaining)}</div>;
}
